// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);

  const overlayEl = document.createElement('div');
  prepareOverlay(overlayEl, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlayEl, image);
    image.style.opacity = '100%';
  };

  return overlayEl;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(overlayEl, image, event, zoomRatio) {
							 
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;

  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

										
  overlayEl.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlayEl.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatios, startEvent) {
  const overlayEl = createOverlay(image);

  let zoomIndex = 0;
  let lastEvent = startEvent;

  // mouse move updates
  overlayEl.addEventListener('mousemove', (event) => {
    lastEvent = event;
    moveWithHover(overlayEl, image, event, zoomRatios[zoomIndex]);
  });

  // CLICK cycles zoom
  overlayEl.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    zoomIndex = (zoomIndex + 1) % zoomRatios.length;

    // re-render zoom at last known cursor position
    moveWithHover(overlayEl, image, lastEvent || event, zoomRatios[zoomIndex]);
  });

  // DOUBLE-CLICK closes
  overlayEl.addEventListener('dblclick', (event) => {
    event.preventDefault();
    event.stopPropagation();
    overlayEl.remove();
  });

  // mouse leave closes (keep Dawn behavior)
  overlayEl.addEventListener('mouseleave', () => overlayEl.remove());

  // Initial position (important: do it after overlay exists)
  // If image isn't loaded yet, this will re-run on first mousemove.
  setTimeout(() => {
    if (lastEvent) moveWithHover(overlayEl, image, lastEvent, zoomRatios[zoomIndex]);
  }, 0);
}

function enableZoomOnHover(zoomRatios = [2, 3, 4, 4.5]) {
  // Use event delegation so we don't break Shopify's media gallery behavior
  document.addEventListener('click', (event) => {
    const image = event.target.closest('.image-magnify-hover');
    if (!image) return;

    // ✅ IMPORTANT: If the click came from a thumbnail, DO NOTHING.
    // Dawn thumbnails are usually inside .thumbnail / .thumbnail-list / Slider-Thumbnails
    const isThumbnail =
      image.closest('.thumbnail') ||
      image.closest('.thumbnail-list') ||
      image.closest('[id^="Slider-Thumbnails"]') ||
      image.closest('[data-thumbnail]');

    if (isThumbnail) return;

    // ✅ Only magnify when the image is in the MAIN media area (active media)
    const isInMainMedia =
      image.closest('.product__media') ||
      image.closest('.product-media-container') ||
      image.closest('.product__media-item');

    if (!isInMainMedia) return;

    event.preventDefault();
    event.stopPropagation();
    magnify(image, zoomRatios, event);
  });
}

enableZoomOnHover([2, 3, 4, 4.5]);

